// Types
import { EventTicketTierDraft } from 'helpers/ticketEvents';
// Helpers
import { formatCurrencyString } from 'helpers/formatCurrencyString';
// Ui
import Text from 'ui3/Text/Text';
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './TicketTierRow.module.scss';

type TicketTierRowProps = {
  tier: EventTicketTierDraft;
  /** Left out for a tier the event already sells. */
  onRemove?: () => void;
};

const TicketTierRow = ({ tier, onRemove }: TicketTierRowProps): JSX.Element => (
  <div className={styles.root}>
    <div className={styles.copy}>
      <Text variant="body2Medium">{tier.label}</Text>
      <Text variant="captionRegular" color="lights-low">
        {`${formatCurrencyString(tier.price)} • ${tier.capacity} seats`}
      </Text>
    </div>
    {onRemove && (
      <button
        type="button"
        className={styles.removeButton}
        aria-label={`Remove ${tier.label}`}
        onClick={onRemove}
      >
        <MillionsIcon name="trash" size={24} />
      </button>
    )}
  </div>
);

export default TicketTierRow;
